import { FC } from 'react';
import Box, { BoxProps } from '@mui/material/Box';

type Props = Pick<BoxProps, 'sx' | 'className'> & {
  // Pins the chip to the top-right corner of a `position: relative` parent.
  corner?: boolean;
};

const cornerSx = {
  position: 'absolute',
  top: 0,
  right: 0,
  transform: 'translate(35%, -50%)',
  pointerEvents: 'none',
  zIndex: 1,
} as const;

const NewChip: FC<Props> = ({ sx, className, corner = false }) => {
  return (
    <Box
      component="span"
      aria-label="New product"
      className={className}
      sx={{
        display: 'inline-block',
        backgroundColor: 'secondary.main',
        color: '#fff',
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: 1,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        padding: '4px 10px',
        borderRadius: '999px',
        whiteSpace: 'nowrap',
        ...(corner && cornerSx),
        ...sx,
      }}
    >
      NEW
    </Box>
  );
};

export default NewChip;
